import React, { useEffect, useState } from "react";
import { Wheel } from "react-custom-roulette";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Typography, Box } from "@mui/material";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData } from "../../Utility/API";

// Same visual design as the promo wheel (screens/BuyCoins/WheelofFortune.js) — only the
// data source (popup_wof_win) and claim routing (PACKAGE -> real buy-coins deep link)
// differ. Keep the two designs in sync if the promo wheel's look changes.
const PopupWheel = ({ open, popupId, userId, onClose, onCredited, onPackage }) => {
  const [segments, setSegments] = useState([]);
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeIndex, setPrizeIndex] = useState(null);
  const [spinning, setSpinning] = useState(false);

  useEffect(() => {
    if (!open || !userId) return;
    setPrizeIndex(null);
    setMustSpin(false);
    setSpinning(false);
    getAllData(`${endPoints.api.POPUP_WOF_ALL}/${userId}`)
      .then((res) => {
        if (res?.status === "success") {
          setSegments(
            (res?.data || []).map((s) => ({
              id: s.id,
              wofType: s.wofType,
              probability: Number(s.wofProbability) || 0,
              color: s.wofColor || "#3B82F6",
              label: s.wofType === "PACKAGE" ? `${s.label} Pack` : s.label,
            }))
          );
        }
      })
      .catch((e) => console.error(e));
  }, [open, userId]);

  const wheelData = segments.map((s) => ({
    option: s.label,
    style: { backgroundColor: s.color, textColor: "#000" },
  }));

  const handleSpin = () => {
    if (!segments.length || spinning) return;
    const total = segments.reduce((sum, s) => sum + s.probability, 0);
    const cumulative = segments.reduce((acc, s, i) => {
      acc.push((acc[i - 1] || 0) + s.probability);
      return acc;
    }, []);
    const rand = Math.random() * total;
    let index = cumulative.findIndex((value) => rand < value);
    if (index < 0) index = segments.length - 1;
    setPrizeIndex(index);
    setSpinning(true);
    setMustSpin(true);
  };

  const handleSpinStop = async () => {
    setMustSpin(false);
    const landed = segments[prizeIndex];
    if (!landed) {
      setSpinning(false);
      return;
    }
    try {
      const response = await addData(endPoints.api.POPUP_WOF_CLAIM, {
        userId,
        wofId: landed.id,
        popupId,
      });
      const result = response?.data?.data;
      if (result?.result === "package") {
        onPackage && onPackage(result);
      } else if (result?.result === "credited") {
        onCredited && onCredited(`You won ${landed.label}! It has been credited to your account.`);
      } else if (result?.result === "already_claimed") {
        onCredited && onCredited("This wheel reward was already claimed.");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSpinning(false);
      onClose && onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!spinning) onClose && onClose();
      }}
      maxWidth="sm"
      fullWidth
    >
      <Box
        sx={{
          background: "radial-gradient(circle at center, #0a0a23 40%, #000)",
          color: "#fff",
          textAlign: "center",
          padding: 2,
          position: "relative",
          overflowX: "hidden",
          overflowY: "hidden",
          paddingBottom: "50px",
          height: "120%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <IconButton
          onClick={() => {
            if (!spinning) onClose && onClose();
          }}
          sx={{ position: "absolute", right: 10, top: 10, color: "#fff" }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" fontWeight="bold">
          Spin & Win!
        </Typography>

        <Box display="flex" justifyContent="center" alignItems="center" position="relative" mt={2}>
          <Box
            sx={{
              border: "8px solid #FFD700",
              borderRadius: "50%",
              padding: 1,
              backgroundColor: "#111",
            }}
          >
            {wheelData.length > 0 && (
              <Wheel
                mustStartSpinning={mustSpin}
                prizeNumber={prizeIndex ?? 0}
                data={wheelData}
                onStopSpinning={handleSpinStop}
                outerBorderColor="#FFD700"
                radiusLineColor="#fff"
                radiusLineWidth={1}
                outerBorderWidth={4}
              />
            )}
          </Box>
          {prizeIndex == null && (
            <Button
              onClick={handleSpin}
              variant="contained"
              disabled={!wheelData.length}
              sx={{
                position: "absolute",
                backgroundColor: "#ff004c",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "18px",
                border: "4px solid #fff",
                borderRadius: "50%",
                width: 90,
                height: 90,
                zIndex: 10,
                textTransform: "uppercase",
                boxShadow: "0 0 15px #ff004c",
              }}
            >
              Spin
            </Button>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default PopupWheel;
